import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-full-width-loader',
  templateUrl: './full-width-loader.component.html',
  styleUrls: ['./full-width-loader.component.css']
})
export class FullWidthLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
